module.exports = __webpack_public_path__ + "img/bm-blog.324c81d6.jpg";